import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import classNames from 'classnames';
import { getQuartz } from 'cron-to-quartz';
import { ref, remove, update } from 'firebase/database';
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Cron } from 'react-js-cron';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import ruLocales from './ruLocales';
import uaLocales from './uaLocales';
import { getScheduleTeacher, getStudentView, getTeacher } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import InfoBox from '../../Components/InfoBox';
import NoItems from '../../Components/NoItems';
import { throwErrorRollbar } from '../../index';

import 'react-js-cron/dist/styles.css';
import './style.scss';

const ScheduleEditor = ({ mail }) => {
  const [locale, setLocale] = useState();
  const [crons, setCrons] = useState([{ id: uuidv4(), cron: sessionStorage.getItem('cron') }]);
  const [infobox, setInfobox] = useState(false);
  const [infoStatus, setInfoStatus] = useState('');
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [hideBtn, setHideBtn] = useState(false);
  const [editCronId, setEditCronId] = useState('');
  const [disabledBtns, setDisabledBtns] = useState(new Array(crons.length).fill(false));
  const [newCronIndex, setNewCronIndex] = useState(-1);

  const allowedPeriods = ['day', 'week', 'month'];
  const durationValues = ['30', '45', '60', '75', '90', '105', '120'];

  const createButtonRef = useRef(null);

  const params = useParams();
  const { t, i18n } = useTranslation();

  const fetchStudentSchedule = async () => {
    await getScheduleTeacher(params.id, params.name).then(response => {
      const resp = response.val();
      const filteredSchedule = Object.values(resp || {}).filter(el => {
        if (el.subject === params.name) {
          return true;
        }
        return false;
      });
      setCrons(filteredSchedule);
    });
  };

  useEffect(() => {
    fetchStudentSchedule();
  }, [disabledBtns]);

  useEffect(() => {
    if (crons.length === 0 && createButtonRef.current) {
      createButtonRef.current.click();
    }
  }, [crons]);

  useEffect(() => {
    let updatedCrons = crons.map(item => {
      if (item.duration === null || item.duration === undefined || item.duration === '') {
        sessionStorage.setItem('duration', 30);
        return { ...item, duration: 30 };
      }
      return item;
    });

    setCrons(updatedCrons);
  }, []);

  useEffect(() => {
    if (i18n.language === 'ua') {
      setLocale(uaLocales);
    } else if (i18n.language === 'ru') {
      setLocale(ruLocales);
    }
  }, [i18n.language]);

  const setCronDuration = (id, event) => {
    const durationValue =
      event.target.value === null ||
      event.target.value === undefined ||
      event.target.value === 0 ||
      event.target.value === ''
        ? 30
        : Number(event.target.value);

    let updatedCrons = crons.map(item => {
      if (item.id === id) {
        sessionStorage.setItem('duration', durationValue);
        return { ...item, duration: durationValue };
      }
      return item;
    });

    setCrons(updatedCrons);
  };

  const setCronValue = (id, value) => {
    let updatedCrons = crons.map(item => {
      const quartz = getQuartz(value)[0].join(' ');

      if (item.id === id) {
        sessionStorage.setItem('cron', value);
        sessionStorage.setItem('quartz', quartz);
        return { ...item, cron: value, quartz: quartz };
      }
      return item;
    });

    setCrons(updatedCrons);
  };

  const handleLoad = () => {
    const newCron = {
      id: uuidv4(),
      cron: '',
    };
    setDisabledBtn(true);
    const updatedCrons = [...crons, newCron];
    setCrons(updatedCrons);
    setNewCronIndex(updatedCrons.length - 1);
  };

  const handleSave = async () => {
    try {
      const scheduleData = {};
      const [teacherResponse, studentResponse] = await Promise.all([getTeacher(mail), getStudentView(params.id)]);

      const teacher = teacherResponse.val();
      const student = studentResponse.val();
      const id = uuidv4();

      // const teacherSubjects = Object.keys(teacher.schedule || {});
      const studentSubjects = Object.keys(student.schedule || {});

      // const teacherHasExistingCron = teacherSubjects.some((subject) => {
      //   if (teacher.schedule[subject]) {
      //     const cronsListTeacher = Object.values(teacher.schedule[subject]);

      //     return cronsListTeacher.some((cron) => {
      //       return cron.cron === sessionStorage.getItem('cron');
      //     });
      //   }
      //   return false;
      // });

      const studentHasExistingCron = studentSubjects.some(subject => {
        if (student.schedule[subject]) {
          const cronsListStudent = Object.values(student.schedule[subject]);

          return cronsListStudent.some(cron => {
            return cron.cron === sessionStorage.getItem('cron');
          });
        }
        return false;
      });

      if (
        // teacherHasExistingCron ||
        studentHasExistingCron
      ) {
        setInfobox(true);
        setInfoStatus('error');
        setDisabledBtn(false);

        setTimeout(() => {
          setInfobox(false);
        }, 3000);

        fetchStudentSchedule();
      } else {
        scheduleData[id] = {
          id: id,
          cron: sessionStorage.getItem('cron'),
          quartz: sessionStorage.getItem('quartz'),
          duration: Number(sessionStorage.getItem('duration')),
          subject: params.name,
          teacherId: mail,
          teacher: teacher.FIO,
          student: student.FIO,
        };

        sessionStorage.removeItem('cron');
        sessionStorage.removeItem('quartz');
        sessionStorage.removeItem('duration');

        await Promise.all([
          update(ref(database, `Teachers/${mail}/schedule/${params.name}`), scheduleData),
          update(ref(database, `Students/${params.id}/schedule/${params.name}`), scheduleData),
        ]);

        fetchStudentSchedule();

        setInfobox(true);
        setInfoStatus('success');
        setDisabledBtns(new Array(crons.length).fill(false));
        setDisabledBtn(false);
        setNewCronIndex(null);

        setTimeout(() => {
          setInfobox(false);
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  const removeCron = async id => {
    try {
      await remove(ref(database, `Students/${params.id}/schedule/${params.name}/${id}`));

      await remove(ref(database, `Teachers/${mail}/schedule/${params.name}/${id}`));

      fetchStudentSchedule();
      setInfobox(true);
      setInfoStatus('delete');
      setDisabledBtn(false);

      setTimeout(() => {
        setInfobox(false);
      }, 3000);
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  const editCron = async (id, index) => {
    try {
      setEditCronId(id);
      const newDisabledBtns = [...disabledBtns];
      newDisabledBtns[index] = true;
      setDisabledBtns(newDisabledBtns);
      setDisabledBtn(true);
      setHideBtn(true);
      const selectedCron = crons.find(item => item.id === id);
      sessionStorage.setItem('cron', selectedCron.cron);
      sessionStorage.setItem('quartz', selectedCron.quartz);
      sessionStorage.setItem('duration', selectedCron.duration.toString());
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  const handleEditSave = async editCronId => {
    try {
      await remove(ref(database, `Students/${params.id}/schedule/${params.name}/${editCronId}`));

      await remove(ref(database, `Teachers/${mail}/schedule/${params.name}/${editCronId}`));

      handleSave();

      fetchStudentSchedule();
      setHideBtn(false);
      setInfobox(true);
      setInfoStatus('edit');
      setDisabledBtns(new Array(crons.length).fill(false));
      setTimeout(() => {
        setInfobox(false);
      }, 3000);
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  return (
    <div className="schedule-editor container">
      <h2>
        {t('createSchedule')}, {t(params.name)}
      </h2>

      {crons.length ? (
        <ul className="schedule-editor-list">
          {crons.map((el, index) => {
            return (
              <li
                key={el.id}
                className={classNames('schedule-editor-item', {
                  disabled: !disabledBtns[index],
                  visible: newCronIndex === index,
                })}
              >
                <FormControl className="schedule-editor-duration">
                  <span className="duration-title">{t('duration')}</span>
                  <Select
                    className="duration-select"
                    onChange={e => {
                      setCronDuration(el.id, e);
                    }}
                    value={el.duration == 0 || el.duration == '' ? 30 : el.duration}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    {durationValues.map(item => {
                      return (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <span className="duration-title">{t('minutes')}</span>
                </FormControl>

                <Cron
                  value={el.cron}
                  allowedPeriods={allowedPeriods}
                  locale={locale}
                  setValue={value => setCronValue(el.id, value)}
                  // mode="single"
                  periodicityOnDoubleClick={false}
                  removePrefixSuffix={false}
                  clearButton={false}
                />

                <div className="actions actions-wrap">
                  <div className="tooltipe-wrap">
                    <button
                      type="button"
                      className="btn btn-icon btn-active"
                      onClick={() => {
                        editCron(el.id, index);
                      }}
                    >
                      <span className="icon icon-edit-1"></span>
                    </button>
                    <div className="tooltipe">{t('update')}</div>
                  </div>

                  <div className="tooltipe-wrap">
                    <button
                      type="button"
                      className="btn btn-icon btn-active"
                      onClick={() => {
                        removeCron(el.id);
                      }}
                    >
                      <span className="icon icon-delete"></span>
                    </button>
                    <div className="tooltipe">{t('delete')}</div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <NoItems
          titleNoItems={t('The student does not yet have a timetable for this subject. Create your first schedule.')}
        />
      )}

      <div className="btn-wrap">
        <button
          className={classNames('btn btn-primary more btn-active', {
            disabled: disabledBtn,
          })}
          ref={createButtonRef}
          onClick={handleLoad}
        >
          {t('create')}
        </button>
        <button
          className={classNames('btn btn-primary more btn-active', {
            disabled: !disabledBtn,
            hide: hideBtn,
          })}
          onClick={handleSave}
        >
          {t('save')}
        </button>
        <button
          className={classNames('btn btn-primary more btn-active', {
            hide: !hideBtn,
          })}
          onClick={() => handleEditSave(editCronId)}
        >
          {t('Save edit')}
        </button>
        <Link to={`/schedule/${mail}`} className="btn btn-primary more btn-active" onClick={handleLoad}>
          {t("to the teacher's schedule")}
        </Link>
      </div>

      {infobox && <InfoBox infoStatus={infoStatus} />}
    </div>
  );
};

export default ScheduleEditor;
